import { Card, Paragraph } from "@digdir/designsystemet-react";
import type { FC, ReactNode } from "react";
import { AreaSeparator } from "../AreaSeparator";
import "./TooltipCard.css";

interface TooltipCardProps {
    title?: string | number;
    children: ReactNode;
}

export const TooltipCard: FC<TooltipCardProps> = ({ title, children }) => {
    return (
        <Card className="tooltip-card">
            {title !== undefined && title !== null && (
                <>
                    <Paragraph>{title}</Paragraph>
                    <AreaSeparator />
                </>
            )}
            {children}
        </Card>
    );
};
